<template>
  <td class="operative-table-kpi-value" :class="{ 'text-left': align === 'left', 'text-center': align === 'center', 'text-right': align === 'right' }">
    <Semaphore :title="label" :value="(scaleValue || {}).rank" :class="{ 'm-0': hideLabel }" />
    <strong v-if="strong" :class="{ 'sr-only': hideLabel }">
      <template v-if="showValue && null !== value">
        {{ value | round }}
      </template>
      <template v-else>
        {{ label }}
      </template>
    </strong>
    <span v-else :class="{ 'sr-only': hideLabel }">
      <template v-if="showValue && null !== value">
        {{ value | round }}
      </template>
      <template v-else>
        {{ label }}
      </template>
    </span>
  </td>
</template>

<script>

import formatRound from '@/filters/formatRound.js';
import Semaphore from '@/views/components/Operative/Semaphore.vue';

export default {
  components: { Semaphore },
  filters: {
    round: formatRound,
  },
  props: {
    rank: {
      type: Number,
      default: null,
    },
    value: {
      type: Number,
      required: false,
    },
    strong: {
      type: Boolean,
      default: false,
    },
    scale: {
      type: Object,
      default: () => null,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: 'default',
    },
    showValue: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      defaultScale: {
        1: { label: 'Insufficiente', rank: 1 },
        2: { label: 'Sufficiente', rank: 2 },
        3: { label: 'Discreto', rank: 3 },
        4: { label: 'Buono', rank: 4 },
        5: { label: 'Eccellente', rank: 5 },
      },
    };
  },
  computed: {
    scaleToUse () {
      return this.scale || this.defaultScale;
    },
    scaleValue () {
      if (!Number.isFinite(this.rank)) {
        return null;
      }

      const scaleValue = this.scaleToUse[this.rank];
      if (!scaleValue) {
        return null;
      }

      return scaleValue;
    },
    label () {
      if (!this.scaleValue) {
        return 'NA';
      }

      return this.scaleValue.label;
    },
  },
};

</script>
